/* eslint-disable */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // STEP 1: VERIFY EMAIL
  const handleVerify = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!email.trim()) {
      return setMessage("Please enter your email");
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/verify-email`,
        { email }
      );

      if (res?.data?.success) {
        setStep(2);
        setMessage("Email verified. Please set a new password.");
      } else {
        setMessage("Email not registered");
      }

    } catch (err) {
      setMessage(
        err?.response?.data?.message || "Email not registered"
      );
    } finally {
      setLoading(false);
    }
  };

  // STEP 2: RESET PASSWORD
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!password || !confirmPassword) {
      return setMessage("Please fill all fields");
    }

    if (password.length < 6) {
      return setMessage("Password must be at least 6 characters");
    }

    if (password !== confirmPassword) {
      return setMessage("Passwords do not match");
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/reset-password`,
        { email, password }
      );

      setMessage(res?.data?.message || "Password updated successfully");

      // Reset form after success
      setTimeout(() => {
        setStep(1);
        setEmail("");
        setPassword("");
        setConfirmPassword("");
        setMessage("");
      }, 2000);

    } catch (err) {
      setMessage(
        err?.response?.data?.message || "Error updating password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-wrapper login-body">
      <div className="login-wrapper">
        <div className="container">
          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">

                <h1>Verify Email</h1>

                <p className="account-subtitle">
                  {step === 1
                    ? "Enter your registered email"
                    : "Create your new password"}
                </p>

                {/* STEP 1 */}
                {step === 1 && (
                  <form onSubmit={handleVerify}>
                    <div className="input-block mb-3">
                      <label>Email Address</label>
                      <input
                        className="form-control"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter registered email"
                        required
                      />
                    </div>

                    <button
                      className="btn btn-primary w-100"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Verifying..." : "Verify"}
                    </button>
                  </form>
                )}

                {/* STEP 2 */}
                {step === 2 && (
                  <form onSubmit={handleResetPassword}>
                    <div className="input-block mb-3">
                      <label>New Password</label>
                      <input
                        className="form-control"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter new password"
                        required
                      />
                    </div>

                    <div className="input-block mb-3">
                      <label>Confirm Password</label>
                      <input
                        className="form-control"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm new password"
                        required
                      />
                    </div>

                    <button
                      className="btn btn-success w-100"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Updating..." : "Reset Password"}
                    </button>
                  </form>
                )}

                {/* MESSAGE */}
                {message && (
                  <p
                    className={`text-center mt-3 ${
                      message.toLowerCase().includes("success")
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {message}
                  </p>
                )}

                <div className="text-center mt-3">
                  <Link to="/login">Back to Login</Link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;